import { useEffect, useState } from "react";
import type { EditorEvents } from "@tiptap/react";
import { WordCounter } from "~/components/indicators/word-counter";
import { CircleColorType } from "~/components/indicators/circle-counter";
import { MAX_BOOK_DESCRIPTION_WORDS_COUNT } from "~/shared/constants/misc";

import { useCurrentEditor } from "./editor-provider";
import { countWords } from "~/pages/product-details/tabs/book-description-tab/utils";

export function EditorWordCount() {
  const { editor } = useCurrentEditor();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!editor || editor.isDestroyed) {
      return;
    }

    function setWordCount(text: string) {
      setCount(countWords(text));
    }

    function onTransaction(props: EditorEvents["transaction"]) {
      if (!props.transaction.docChanged || props.editor.isDestroyed) {
        return;
      }

      setWordCount(props.editor.getText());
    }

    editor.on("transaction", onTransaction);

    setWordCount(editor.getText());

    return () => {
      editor.off("transaction", onTransaction);
    };
  }, [editor]);

  return (
    <WordCounter
      count={count}
      maxCount={MAX_BOOK_DESCRIPTION_WORDS_COUNT}
      color={CircleColorType.Green}
    />
  );
}
